import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  standalone: false,
})
export class UploadDialogComponent {
  leadId: string | undefined;

  constructor(
    public dialogRef: MatDialogRef<UploadDialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      leadId: string;
    },
  ) {
    this.leadId = data.leadId;
  }
}
